/* eslint-disable no-param-reassign */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { AuthenticationDetails, CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js';
import { BehaviorSubject, catchError, finalize, forkJoin, map, Observable, of, switchMap, takeWhile, tap, throwError } from 'rxjs';
import { AuthBridgeService } from '@procom-labs/bridge';
import { SiteList } from '../config';
import { ActivityType, AppTypes, AuthErrorCodes, AuthPortalRouteMaps, AuthProfileType, AuthSignupType, ClientQueryParams, gtmEvents, gtmEventsPrefix, HTTPResponseStatus, InjectableConfig, InjectableServices, LoginTypes, popupWindowNames, ProfileCompletionStatus, SocialLoginType, SocialRoutes } from '../enums';
import { authStorage, fboAuthStorage, guestSessionStorage, restrictedViewSessionStorage, restrictedViewStorage, siteConfigStorage } from '../local-storage';
import { MfaTypes, SuperSubject } from '../models';
import { errorToString, getAuthPortalUrl, getClientCode, getClientName, getLoginType, getMfeAuthPortalUrl, getVendorCode, openPopupWindow, themeModeStorage } from '../util';
import { WindowedObservable } from '../windowed-observable';
import { awsService } from './aws.service';
import { BaseConfigService } from './base-config.service';
import { OnboardingService } from './onboarding.service';
import { PerformanceTrackingService } from './performance-tracking.service';
export var LogoutMode = /*#__PURE__*/ function(LogoutMode) {
    LogoutMode["logout"] = "logout";
    LogoutMode["sessionExpired"] = "sessionExpired";
    LogoutMode["notAllowed"] = "notAllowed";
    return LogoutMode;
}({});
var gtmSocialEvent = function() {
    dataLayer.push({
        event: "form-".concat(localStorage.getItem('socialLoginContext')),
        submissionStatus: 'true',
        email: 'null',
        loginWith: localStorage.getItem('socialLoginType')
    });
    localStorage.removeItem('socialLoginType');
    localStorage.removeItem('socialLoginContext');
};
var gtmInitialLoginEvent = function(user) {
    var currentLoginType = getLoginType(user.currentProfileType);
    dataLayer.push({
        event: gtmEvents.InitialLogin,
        userId: user.id,
        portalType: currentLoginType
    });
};
// This has to be fixed (anti-pattern). We must avoid having to pass too many arguments
// The way to approach this is decompose the service, and also to start finding better ways to get access
// to the apis or values that the arguments passed provide
export var AuthService = /*#__PURE__*/ function(BaseConfigService) {
    "use strict";
    _inherits(AuthService, BaseConfigService);
    function AuthService() {
        _class_call_check(this, AuthService);
        var _this;
        _this = _call_super(this, AuthService), _define_property(_this, "authDataSubject", new BehaviorSubject(null)), _define_property(_this, "authData$", _this.authDataSubject.asObservable()), _define_property(_this, "siteConfig$", void 0), _define_property(_this, "currentUserSubject", new BehaviorSubject(null)), _define_property(_this, "currentUser$", _this.currentUserSubject.asObservable()), _define_property(_this, "currentCognitoUserSubject", new SuperSubject(null)), _define_property(_this, "currentCognitoUser$", _this.currentCognitoUserSubject.observable$), // Needed to resend MFA SMS code
        _define_property(_this, "currentCognitoUserPasswordSubject", new SuperSubject('')), _define_property(_this, "isMfaCodeRequestedSubject", new SuperSubject(false)), _define_property(_this, "isMfaCodeRequested$", _this.isMfaCodeRequestedSubject.observable$), _define_property(_this, "cognitoUserHasMultipleMfaMethodsSubject", new SuperSubject(false)), _define_property(_this, "cognitoUserHasMultipleMfaMethods$", _this.cognitoUserHasMultipleMfaMethodsSubject.observable$), _define_property(_this, "baseEndpoint", void 0), _define_property(_this, "authStorage", void 0), _define_property(_this, "fboAuthStorage", void 0), _define_property(_this, "guestSessionStorage", void 0), _define_property(_this, "siteConfigStorage", void 0), _define_property(_this, "i18nConfig", null), _define_property(_this, "authBridgeService", AuthBridgeService.getOrCreate()), _define_property(_this, "onboardingService", OnboardingService.getOrCreate()), _define_property(_this, "performanceTrackingService", PerformanceTrackingService.getOrCreate()), _define_property(_this, "pool", void 0), _define_property(_this, "accountEndpoint", void 0), _define_property(_this, "clientEndpoint", void 0), _define_property(_this, "userDetailEndpoint", void 0), _define_property(_this, "awsClientId", void 0), _define_property(_this, "awsAuthUrl", void 0), _define_property(_this, "linkedinAuthUrl", void 0), _define_property(_this, "linkedinClientId", void 0), _define_property(_this, "isResumeCopilotFeatureEnabled", void 0), _define_property(_this, "enablePerformanceTracking", void 0), _define_property(_this, "siteConfigSubject", void 0), _define_property(_this, "currentUserProfileSubject", new BehaviorSubject(null)), _define_property(_this, "currentUserProfile$", _this.currentUserProfileSubject.asObservable()), _define_property(_this, "currentUserHiringManagersSubject", new SuperSubject([])), _define_property(_this, "currentUserHiringManagers$", _this.currentUserHiringManagersSubject.observable$), _define_property(_this, "nationalAccountManagerSubject", new SuperSubject(null)), _define_property(_this, "nationalAccountManager$", _this.nationalAccountManagerSubject.observable$), _define_property(_this, "clientListSubject", new SuperSubject([])), _define_property(_this, "clientList$", _this.clientListSubject.observable$), _define_property(_this, "isLoadingSubject", new SuperSubject(false)), _define_property(_this, "isLoading$", _this.isLoadingSubject.observable$), _define_property(_this, "isUserPermissionLoadingSubject", new SuperSubject(false)), _define_property(_this, "isUserPermissionLoading$", _this.isUserPermissionLoadingSubject.observable$), _define_property(_this, "userPermissionsSubject", new SuperSubject(null)), _define_property(_this, "userPermissions$", _this.userPermissionsSubject.observable$), _define_property(_this, "refreshPermissionSubject", new SuperSubject(true)), _define_property(_this, "refreshPermission$", _this.refreshPermissionSubject.observable$), _define_property(_this, "isAuthRefreshing", false), _define_property(_this, "failedRequestList", []), // arrow syntax has to be used to pass `this` reference
        _define_property(_this, "handleResponse", function(response) {
            if (_this.enablePerformanceTracking === 'true') {
                _this.performanceTrackingService.sendPerfTracking({
                    response: response
                });
            }
            return response;
        }), _define_property(_this, "handleRequestInterceptor", function(config) {
            if (_this.environment.ENABLE_PERFORMANCE_TRACKING === 'true') {
                var metadataPerfTracking = _this.performanceTrackingService.getRequestPerfTracking(config);
                if (metadataPerfTracking) config.metadataPerfTracking = metadataPerfTracking;
            }
            if (config.headers) {
                var storedData = authStorage.get(_this.isResumeApp);
                var guestSessionData = guestSessionStorage.get();
                var restrictedViewData = restrictedViewSessionStorage.get();
                if (_this.isClientApp && (guestSessionData === null || guestSessionData === void 0 ? void 0 : guestSessionData.token) && !config.headers.authorization && (restrictedViewData === null || restrictedViewData === void 0 ? void 0 : restrictedViewData.allowedPathname) && window.location.pathname.includes(restrictedViewData.allowedPathname)) {
                    // In restricted view we need to use a different token
                    config.headers.authorization = "Bearer ".concat(guestSessionData.token);
                } else if ((storedData === null || storedData === void 0 ? void 0 : storedData.token) && !config.headers.authorization) {
                    config.headers.authorization = "Bearer ".concat(storedData.token);
                }
                config.headers.Accept = config.headers.Accept || 'application/json';
                config.headers['Content-Type'] = config.headers['Content-Type'] || 'application/json';
                var lang = localStorage.getItem('i18nextLng');
                if (lang) {
                    config.headers['Accept-Language'] = lang;
                    // For FBO
                    config.headers['Portal-Locale'] = "".concat(lang, "-CA");
                }
            }
            return config;
        }), _define_property(_this, "handleResponseError", function(error) {
            var response = error.response, config = error.config;
            if ((response === null || response === void 0 ? void 0 : response.status) === HTTPResponseStatus.Unauthorized) {
                if (config === null || config === void 0 ? void 0 : config.suppress401Redirect) return Promise.reject(error);
                var authData = _this.authStorage.get();
                var refreshToken = authData === null || authData === void 0 ? void 0 : authData.refreshToken;
                if (!(config === null || config === void 0 ? void 0 : config.retry) && refreshToken && config.url.indexOf('refresh') === -1) {
                    if (_this.isAuthRefreshing) {
                        return new Promise(function(resolve, reject) {
                            _this.failedRequestList.push({
                                requestConfig: _object_spread_props(_object_spread({}, config), {
                                    cancelToken: null,
                                    headers: _object_spread_props(_object_spread({}, config.headers), {
                                        authorization: null
                                    }),
                                    retry: true
                                }),
                                resolve: resolve,
                                reject: reject
                            });
                        });
                    }
                    return new Promise(function(resolve, reject) {
                        _this.refreshAuth(refreshToken).pipe(switchMap(function() {
                            _this.processFailedRequestList();
                            return _this.axios.request(_object_spread_props(_object_spread({}, config), {
                                cancelToken: null,
                                headers: _object_spread_props(_object_spread({}, config.headers), {
                                    authorization: null
                                }),
                                retry: true
                            }));
                        })).subscribe({
                            next: function(resp) {
                                resolve(resp);
                            },
                            error: function() {
                                _this.processFailedRequestList(error);
                                reject(error);
                            }
                        });
                    });
                }
                if (!config.headers['api-key']) {
                    _this.logout({
                        to: "".concat(window.location.pathname).concat(window.location.search || ''),
                        mode: "sessionExpired",
                        loginType: localStorage.getItem('loginType') || undefined
                    });
                }
            } else if (response && response.status >= 400 && response.status !== 404) {
                _this.rollbar.error(error);
            }
            if (response && _this.enablePerformanceTracking === 'true') {
                _this.performanceTrackingService.sendPerfTracking({
                    response: response,
                    isError: true
                });
            }
            return Promise.reject(error);
        });
        _this.pool = new CognitoUserPool({
            UserPoolId: _this.environment.cognito.AWS_USERPOOL_ID,
            ClientId: _this.environment.cognito.AWS_CLIENT_ID
        });
        _this.baseEndpoint = _this.environment.AUTH_API_URL;
        _this.awsClientId = _this.environment.cognito.AWS_CLIENT_ID;
        _this.awsAuthUrl = _this.environment.cognito.AWS_AUTH_URL;
        _this.linkedinAuthUrl = _this.environment.LINKEDIN.AUTH_URL;
        _this.linkedinClientId = _this.environment.LINKEDIN.CLIENT_ID;
        _this.isResumeCopilotFeatureEnabled = _this.environment.IS_RESUME_COPILOT_FEATURE_ENABLED;
        _this.enablePerformanceTracking = _this.environment.ENABLE_PERFORMANCE_TRACKING;
        _this.authStorage = authStorage;
        _this.fboAuthStorage = fboAuthStorage;
        _this.guestSessionStorage = guestSessionStorage;
        _this.siteConfigStorage = siteConfigStorage;
        _this.accountEndpoint = "".concat(_this.baseEndpoint, "/Account");
        _this.clientEndpoint = "".concat(_this.baseEndpoint, "/Client");
        _this.userDetailEndpoint = "".concat(_this.baseEndpoint, "/user");
        _this.siteConfigSubject = new SuperSubject(_this.siteConfigStorage.get());
        _this.siteConfig$ = _this.siteConfigSubject.observable$;
        _this.axios.interceptors.request.use(_this.handleRequestInterceptor);
        _this.axios.interceptors.response.use(_this.handleResponse, _this.handleResponseError);
        return _this;
    }
    _create_class(AuthService, [
        {
            key: "i18n",
            get: function get() {
                if (!this.i18nConfig) {
                    this.i18nConfig = new WindowedObservable(InjectableConfig.I18n).getLastEvent();
                }
                return this.i18nConfig;
            }
        },
        {
            key: "siteConfigurationId",
            get: function get() {
                return this.siteConfigSubject.value ? this.siteConfigSubject.value.id : '';
            }
        },
        {
            key: "siteFboTenantName",
            get: function get() {
                var _this_siteConfigSubject_value;
                return ((_this_siteConfigSubject_value = this.siteConfigSubject.value) === null || _this_siteConfigSubject_value === void 0 ? void 0 : _this_siteConfigSubject_value.fboTenantName) || 'Procom';
            }
        },
        {
            key: "isAuthenticated",
            get: function get() {
                return !!this.currentUserSubject.value;
            }
        },
        {
            key: "currentUser",
            get: function get() {
                return this.currentUserSubject.value;
            },
            set: function set(userObject) {
                this.currentUserSubject.next(userObject);
                if (userObject) {
                    var currentProfile = function() {
                        var isHubSite = !getClientCode();
                        var vendorCode = getVendorCode();
                        var clientCode = getClientCode();
                        var userProfile = userObject.profiles.find(function(profile) {
                            return profile.profileType === userObject.currentProfileType && (isHubSite ? profile.vendorCode === vendorCode : profile.clientCode === clientCode);
                        });
                        return userProfile !== null && userProfile !== void 0 ? userProfile : null;
                    };
                    this.currentUserProfileSubject.next(currentProfile());
                }
                if (userObject) {
                    var id = userObject.id, displayName = userObject.displayName, email = userObject.email, preferredLanguage = userObject.preferredLanguage;
                    this.rollbar.configure({
                        payload: {
                            person: {
                                id: id,
                                displayName: displayName,
                                email: email
                            }
                        }
                    });
                    if (preferredLanguage && this.i18n.language !== preferredLanguage.toLowerCase()) {
                        this.i18n.changeLanguage(preferredLanguage);
                    }
                } else {
                    this.rollbar.configure({
                        payload: {
                            person: {
                                id: null
                            }
                        }
                    });
                }
            }
        },
        {
            key: "authPortalBaseUrl",
            get: function get() {
                if (this.mfeType && process.env.NODE_ENV === 'development') {
                    return getMfeAuthPortalUrl(window.location.hostname);
                }
                return getAuthPortalUrl(window.location.hostname);
            }
        },
        {
            key: "clearRestrictedViewStorage",
            value: function clearRestrictedViewStorage() {
                if (restrictedViewStorage.get()) {
                    restrictedViewStorage.clear();
                }
                if (restrictedViewSessionStorage.get()) {
                    restrictedViewSessionStorage.clear();
                }
                if (guestSessionStorage.get()) {
                    guestSessionStorage.clear();
                }
            }
        },
        {
            key: "updateCurrentUserMfaStatus",
            value: function updateCurrentUserMfaStatus(isMfaEnabled) {
                var user = structuredClone(this.currentUserSubject.value);
                if (user) this.currentUser = _object_spread_props(_object_spread({}, user), {
                    isMfaEnabled: isMfaEnabled
                });
            }
        },
        {
            key: "updateProfileCompletionStatusOnSuccess",
            value: function updateProfileCompletionStatusOnSuccess() {
                if (this.userPermissionsSubject.value) {
                    this.userPermissionsSubject.value = _object_spread_props(_object_spread({}, this.userPermissionsSubject.value), {
                        contractorProfileCompletionStatus: ProfileCompletionStatus.Completed
                    });
                }
            }
        },
        {
            key: "authorize",
            value: function authorize(cognitoToken) {
                var _this = this;
                return this.axios.get("".concat(this.accountEndpoint, "/token?originBase=").concat(encodeURIComponent(window.location.origin), "&loginType=").concat(localStorage.getItem(ClientQueryParams.loginType)), {
                    headers: {
                        authorization: "Bearer ".concat(cognitoToken)
                    }
                }).pipe(map(function(param) {
                    var data = param.data;
                    var user = data.user;
                    _this.clearRestrictedViewStorage();
                    _this.setAuthStorage(data);
                    return user;
                }), catchError(function(error) {
                    _this.authStorage.clear();
                    _this.fboAuthStorage.clear();
                    return throwError(function() {
                        return new Error(error);
                    });
                }), finalize(function() {
                    _this.isLoadingSubject.value = false;
                }));
            }
        },
        {
            key: "checkEmailExistence",
            value: function checkEmailExistence(email, profileType, recaptchaToken) {
                var _SiteList_find;
                var hostname = window.location.hostname;
                var clientCode = ((_SiteList_find = SiteList.find(function(portal) {
                    return portal.code && portal.domains.some(function(domain) {
                        return domain.hostname === hostname;
                    });
                })) === null || _SiteList_find === void 0 ? void 0 : _SiteList_find.code) || '';
                var headers = {
                    recaptchaToken: recaptchaToken
                };
                var vendorCode = getVendorCode();
                return this.axios.get("".concat(this.accountEndpoint, "/anonymous-user-info?").concat(new URLSearchParams({
                    email: email,
                    profileType: profileType,
                    vendorCode: vendorCode,
                    clientCode: clientCode,
                    originBase: window.location.origin
                })), {
                    headers: headers
                }).pipe(map(function(param) {
                    var data = param.data;
                    return data;
                }), catchError(function() {
                    return of({
                        isUserExist: false,
                        isPasswordSet: false,
                        skipDiversitySurvey: false,
                        signupType: AuthSignupType.Email,
                        hasRestrictedAccess: false,
                        code: ''
                    });
                }));
            }
        },
        {
            key: "handleUserAuthentication",
            value: function handleUserAuthentication(token, refreshToken, expiredTime, refreshTokenExpiredTime) {
                // Means we have the procom's id token, so we can call fetchUserInfo directly
                if (refreshToken && expiredTime && token && refreshTokenExpiredTime) {
                    var authStoredData = this.authStorage.get();
                    if (authStoredData === null || authStoredData === void 0 ? void 0 : authStoredData.user) {
                        this.authStorage.set({
                            token: token,
                            refreshToken: refreshToken,
                            expiredTime: expiredTime,
                            refreshTokenExpiredTime: refreshTokenExpiredTime,
                            user: _object_spread({}, authStoredData.user),
                            isNewVendorClientContractorUser: null,
                            sendbirdAppId: authStoredData.sendbirdAppId,
                            supportUserId: authStoredData.supportUserId,
                            firstLogin: authStoredData.firstLogin
                        });
                    } else {
                        var _authStoredData_sendbirdAppId, _authStoredData_supportUserId, _authStoredData_firstLogin;
                        this.authStorage.set({
                            token: token,
                            refreshToken: refreshToken,
                            expiredTime: expiredTime,
                            refreshTokenExpiredTime: refreshTokenExpiredTime,
                            user: null,
                            isNewVendorClientContractorUser: null,
                            sendbirdAppId: (_authStoredData_sendbirdAppId = authStoredData === null || authStoredData === void 0 ? void 0 : authStoredData.sendbirdAppId) !== null && _authStoredData_sendbirdAppId !== void 0 ? _authStoredData_sendbirdAppId : null,
                            supportUserId: (_authStoredData_supportUserId = authStoredData === null || authStoredData === void 0 ? void 0 : authStoredData.supportUserId) !== null && _authStoredData_supportUserId !== void 0 ? _authStoredData_supportUserId : null,
                            firstLogin: (_authStoredData_firstLogin = authStoredData === null || authStoredData === void 0 ? void 0 : authStoredData.firstLogin) !== null && _authStoredData_firstLogin !== void 0 ? _authStoredData_firstLogin : null
                        });
                    }
                    this.clearRestrictedViewStorage();
                    return this.fetchUserInfo();
                }
                // If AWS access token we request a procom ID token
                return this.authorize(token);
            }
        },
        {
            key: "getSocialLoginAwsToken",
            value: function getSocialLoginAwsToken(code) {
                var _this = this;
                var headers = {
                    'Content-Type': 'application/x-www-form-urlencoded'
                };
                if (this.awsAuthUrl && this.awsClientId) {
                    var body = new URLSearchParams({
                        grant_type: 'authorization_code',
                        client_id: this.awsClientId,
                        redirect_uri: "".concat(window.location.origin, "/").concat(SocialRoutes.SocialCallbackURL),
                        code: code
                    });
                    return this.axios.post("".concat(this.awsAuthUrl, "/oauth2/token"), body, {
                        headers: headers
                    }).pipe(switchMap(function(param) {
                        var data = param.data;
                        return _this.socialLogin({
                            cognitoAccessToken: data.access_token,
                            tokenType: data.token_type,
                            cognitoIdToken: data.id_token
                        });
                    }));
                }
                return of({});
            }
        },
        {
            key: "socialLogin",
            value: function socialLogin(param) {
                var cognitoIdToken = param.cognitoIdToken, tokenType = param.tokenType, cognitoAccessToken = param.cognitoAccessToken;
                var url = "".concat(this.accountEndpoint, "/signin-social-cognito");
                var headers = {
                    Authorization: "".concat(tokenType, " ").concat(cognitoIdToken)
                };
                var payload = {
                    accessToken: cognitoAccessToken,
                    tokenType: tokenType,
                    originBase: window.location.origin
                };
                return this.axios.post(url, payload, {
                    headers: headers
                }).pipe(tap(function() {
                    gtmSocialEvent();
                }), map(function(param) {
                    var data = param.data;
                    return {
                        token: cognitoIdToken,
                        isNewVendorClientContractorUser: data.isNewVendorClientContractorUser,
                        cognitoAccessToken: cognitoAccessToken,
                        cognitoIdToken: cognitoIdToken
                    };
                }), catchError(function(error) {
                    dataLayer.push({
                        event: "".concat(gtmEventsPrefix.Notification).concat(gtmEvents.FormLogin),
                        submissionStatus: 'false',
                        email: 'null',
                        loginWith: localStorage.getItem('socialLoginType'),
                        errorMessage: errorToString(error)
                    });
                    return throwError(function() {
                        return error;
                    });
                }));
            }
        },
        {
            key: "openSocialMediaLoginWindow",
            value: function openSocialMediaLoginWindow(loginType) {
                localStorage.setItem('socialLoginContext', 'login');
                localStorage.setItem('socialLoginType', loginType);
                var socialLinkHref = (loginType === null || loginType === void 0 ? void 0 : loginType.toLowerCase()) === SocialLoginType.Linkedin.toLowerCase() ? "".concat(this.linkedinAuthUrl, "/authorization?response_type=code&client_id=").concat(this.linkedinClientId, "&redirect_uri=").concat(encodeURIComponent(window.location.origin), "/signin-linkedin-callback&scope=r_liteprofile%20r_emailaddress%20w_member_social") : "".concat(this.awsAuthUrl, "/oauth2/authorize?client_id=").concat(this.awsClientId, "&response_type=code&scope=email+openid+phone+profile&redirect_uri=").concat(window.location.origin, "/").concat(SocialRoutes.SocialCallbackURL, "&identity_provider=").concat(loginType);
                openPopupWindow(socialLinkHref, popupWindowNames.SocialLogin);
            }
        },
        {
            key: "linkedinLogin",
            value: function linkedinLogin(code) {
                var url = "".concat(this.accountEndpoint, "/signin-social-linkedin ");
                var payload = {
                    authorizationCode: code,
                    originBase: window.location.origin,
                    redirectUri: "".concat(window.location.origin, "/signin-linkedin-callback")
                };
                return this.axios.post(url, payload).pipe(tap(function(param) {
                    var data = param.data;
                    gtmSocialEvent();
                    if (data === null || data === void 0 ? void 0 : data.user) gtmInitialLoginEvent(data.user);
                }), map(function(param) {
                    var data = param.data;
                    return data;
                }));
            }
        },
        {
            key: "logout",
            value: function logout(logoutParams) {
                var _this = this;
                var _this_currentUserSubject_value;
                this.authStorage.clear();
                this.fboAuthStorage.clear();
                this.siteConfigStorage.clear();
                var params = {
                    authPortalRoute: 'login',
                    originBase: encodeURIComponent(window.location.origin),
                    callbackURL: encodeURIComponent("".concat(window.location.origin, "/auth-return")),
                    loginType: (logoutParams === null || logoutParams === void 0 ? void 0 : logoutParams.loginType) || LoginTypes.Client
                };
                if (logoutParams === null || logoutParams === void 0 ? void 0 : logoutParams.to) {
                    params.destinationURL = encodeURIComponent(logoutParams === null || logoutParams === void 0 ? void 0 : logoutParams.to);
                }
                var themeMode = themeModeStorage.get();
                if (themeMode) {
                    params.themeMode = themeMode;
                }
                localStorage.setItem(ClientQueryParams.loginType, (logoutParams === null || logoutParams === void 0 ? void 0 : logoutParams.loginType) || LoginTypes.Client);
                this.trackActivity(((_this_currentUserSubject_value = this.currentUserSubject.value) === null || _this_currentUserSubject_value === void 0 ? void 0 : _this_currentUserSubject_value.email) || '', ActivityType.Logout, true).subscribe({
                    complete: function() {
                        window.location.href = "".concat(_this.authPortalBaseUrl, "/logout?").concat(new URLSearchParams(_object_spread_props(_object_spread({}, params), _define_property({}, (logoutParams === null || logoutParams === void 0 ? void 0 : logoutParams.mode) || "logout", 'true'))));
                    }
                });
            }
        },
        {
            key: "handleFetchUserInfo",
            value: function handleFetchUserInfo() {
                var _this = this;
                return new Observable(function(observer) {
                    _this.fetchUserInfo().pipe(takeWhile(function() {
                        return !observer.closed;
                    })).subscribe({
                        next: function(authUser) {
                            if (!authUser || !Array.isArray(authUser.profiles) || !authUser.profiles.length) {
                                observer.error('You do not have any valid profile');
                            } else {
                                observer.complete();
                            }
                        },
                        error: function(err) {
                            if (err && err.response && err.response.status === HTTPResponseStatus.Unauthorized) {
                                _this.authStorage.clear();
                                _this.fboAuthStorage.clear();
                            }
                            observer.error(errorToString(err));
                        }
                    });
                });
            }
        },
        {
            key: "restoreAuthState",
            value: function restoreAuthState() {
                var _this = this;
                return new Observable(function(observer) {
                    if (_this.currentUser) {
                        observer.complete();
                    } else {
                        var storedData = _this.authStorage.get();
                        var now = new Date().getTime();
                        var isValid = storedData && (new Date(storedData.expiredTime).getTime() >= now || storedData.refreshTokenExpiredTime && new Date(storedData.refreshTokenExpiredTime).getTime() >= now);
                        if (isValid) {
                            _this.currentUser = storedData.user ? storedData.user : null;
                            _this.handleFetchUserInfo().pipe(takeWhile(function() {
                                return !observer.closed;
                            })).subscribe({
                                complete: function() {
                                    observer.complete();
                                }
                            });
                        } else {
                            _this.fboAuthStorage.clear();
                            _this.authStorage.clear();
                            observer.complete();
                        }
                    }
                });
            }
        },
        {
            key: "redirectToAuthPortal",
            value: function redirectToAuthPortal(to) {
                var authPortalRoute = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : AuthPortalRouteMaps.Login, loginType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, customParams = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                var params = {
                    // this is not the literal route, but has to match of to the keys in the InitialAuthRoute mapping
                    authPortalRoute: authPortalRoute,
                    // auth portal will return the token back to this route. This route will validate the token and obtain custom JWT token from our backend
                    callbackURL: encodeURIComponent("".concat(window.location.origin, "/auth-return")),
                    originBase: encodeURIComponent(window.location.origin),
                    lang: this.i18n.language
                };
                if (to) {
                    params.destinationURL = encodeURIComponent(to);
                }
                if (loginType) {
                    params.loginType = loginType;
                }
                var themeMode = themeModeStorage.get();
                if (themeMode) {
                    params.themeMode = themeMode;
                }
                window.location.href = "".concat(this.authPortalBaseUrl, "/initial-auth-route?").concat(new URLSearchParams(_object_spread({}, params, customParams)));
            }
        },
        {
            key: "fetchUserInfo",
            value: function fetchUserInfo() {
                var _this = this;
                var _this_guestSessionStorage;
                var guestSessionStorageValue = (_this_guestSessionStorage = this.guestSessionStorage) === null || _this_guestSessionStorage === void 0 ? void 0 : _this_guestSessionStorage.get();
                if (guestSessionStorageValue) {
                    this.setCurrentUser(guestSessionStorageValue);
                    var _ref = guestSessionStorageValue !== null && guestSessionStorageValue !== void 0 ? guestSessionStorageValue : {}, token = _ref.token, user = _ref.user;
                    if (token && user) {
                        return of(user);
                    }
                }
                this.isLoadingSubject.value = true;
                return this.axios.get("".concat(this.accountEndpoint, "/user-info")).pipe(map(function(param) {
                    var data = param.data;
                    var authData = _this.authStorage.get();
                    if (authData) {
                        var _authData_user;
                        _this.setAuthStorage(_object_spread_props(_object_spread({}, authData), {
                            user: _object_spread_props(_object_spread({}, data), {
                                isAccessRestricted: !!(authData === null || authData === void 0 ? void 0 : (_authData_user = authData.user) === null || _authData_user === void 0 ? void 0 : _authData_user.isAccessRestricted)
                            })
                        }));
                    }
                    return data;
                }), finalize(function() {
                    _this.isLoadingSubject.value = false;
                }));
            }
        },
        {
            key: "fetchUserHiringManagers",
            value: function fetchUserHiringManagers() {
                var _this = this;
                this.isLoadingSubject.value = true;
                return this.axios.get("".concat(this.userDetailEndpoint, "/hiring-managers")).pipe(map(function(param) {
                    var data = param.data;
                    _this.currentUserHiringManagersSubject.value = data;
                }), finalize(function() {
                    _this.isLoadingSubject.value = false;
                }));
            }
        },
        {
            key: "fetchNationalAccountManager",
            value: function fetchNationalAccountManager() {
                var _this = this;
                var returnNationalAm = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                this.isLoadingSubject.value = true;
                return this.axios.get("".concat(this.userDetailEndpoint, "/account-managers?returnNationalAm=").concat(returnNationalAm)).pipe(map(function(param) {
                    var data = param.data;
                    if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
                        var _data = _sliced_to_array(data, 1), value = _data[0];
                        _this.nationalAccountManagerSubject.value = value;
                    }
                }), finalize(function() {
                    _this.isLoadingSubject.value = false;
                }));
            }
        },
        {
            key: "directMessageToNationalAccountManager",
            value: function directMessageToNationalAccountManager(param) {
                var id = param.id, messageBody = param.messageBody, entityId = param.entityId, entityType = param.entityType;
                return this.axios.post("".concat(this.baseEndpoint, "/User/").concat(id, "/direct-message"), {
                    messageBody: messageBody,
                    entityId: entityId,
                    entityType: entityType
                });
            }
        },
        {
            key: "updateUserDetail",
            value: function updateUserDetail(id, payload, updateCurrent) {
                var _this = this;
                return this.axios.put("".concat(this.userDetailEndpoint, "/").concat(id), payload).pipe(switchMap(function(param) {
                    var data = param.data;
                    if (updateCurrent) {
                        return _this.fetchUserInfo().pipe(map(function() {}));
                    }
                    return of(data);
                }));
            }
        },
        {
            key: "getUserDetail",
            value: function getUserDetail(id) {
                return this.axios.get("".concat(this.userDetailEndpoint, "/").concat(id)).pipe(map(function(param) {
                    var data = param.data;
                    return data;
                }));
            }
        },
        {
            key: "fetchSiteConfig",
            value: function fetchSiteConfig() {
                var _this = this;
                var vendorCode = getVendorCode();
                return this.axios.get("".concat(this.baseEndpoint, "/SiteConfiguration?baseUrl=").concat(window.location.origin, "&vendorCode=").concat(vendorCode)).pipe(map(function(param) {
                    var data = param.data;
                    _this.siteConfigStorage.set(data);
                    _this.siteConfigSubject.value = data;
                }), catchError(function() {
                    _this.siteConfigStorage.clear();
                    _this.siteConfigSubject.value = null;
                    return of();
                }));
            }
        },
        {
            key: "refreshAuth",
            value: function refreshAuth(token, id) {
                var _this = this;
                this.isAuthRefreshing = true;
                var url = "".concat(this.accountEndpoint, "/token/refresh?").concat(new URLSearchParams({
                    token: token,
                    userId: this.currentUser ? this.currentUser.id : id !== null && id !== void 0 ? id : '',
                    originBase: encodeURIComponent(window.location.origin)
                }));
                if (this.authBridgeService.isFboHost) {
                    if (this.authBridgeService.getAuthRefreshRequest) {
                        return this.authBridgeService.getAuthRefreshRequest().pipe(map(function(data) {
                            if (data) {
                                _this.setAuthStorage(data);
                            } else {
                                _this.clearAuthStorage();
                            }
                        }), catchError(function() {
                            _this.clearAuthStorage();
                            return of();
                        }));
                    }
                    this.clearAuthStorage();
                    return of();
                }
                return this.axios.get(url).pipe(map(function(param) {
                    var data = param.data;
                    _this.setAuthStorage(data);
                }), finalize(function() {
                    _this.isAuthRefreshing = false;
                }));
            }
        },
        {
            key: "impersonateUser",
            value: function impersonateUser(param) {
                var email = param.email, profileType = param.profileType, clientCode = param.clientCode;
                var url = "".concat(this.accountEndpoint, "/support/token");
                return this.axios.post(url, {
                    email: email,
                    profileType: profileType,
                    clientCode: clientCode
                }).pipe(map(function(param) {
                    var data = param.data;
                    return data;
                }));
            }
        },
        {
            key: "setSupportUser",
            value: function setSupportUser(data) {
                this.authStorage.set(data);
                this.authDataSubject.next(data);
                this.currentUser = data.user;
            }
        },
        {
            key: "setCurrentUser",
            value: function setCurrentUser(data) {
                if (data) {
                    this.currentUser = data.user;
                }
            }
        },
        {
            key: "processFailedRequestList",
            value: function processFailedRequestList(error) {
                var _this = this;
                this.failedRequestList.forEach(function(param) {
                    var resolve = param.resolve, reject = param.reject, requestConfig = param.requestConfig;
                    if (error) {
                        reject(error);
                    } else {
                        _this.axios.request(requestConfig).subscribe({
                            next: function(resp) {
                                resolve(resp);
                            },
                            error: function() {
                                reject(error);
                            }
                        });
                    }
                });
                this.failedRequestList = [];
            }
        },
        {
            key: "handleCognitoUserOnSuccess",
            value: function handleCognitoUserOnSuccess(param) {
                var _this = this;
                var cognitoSession = param.cognitoSession, observer = param.observer, isNewUser = param.isNewUser, sendGtmEvent = param.sendGtmEvent, username = param.username;
                if (observer) {
                    var token = cognitoSession.getIdToken().getJwtToken();
                    observer.next({
                        token: token
                    });
                    this.trackActivity(username, isNewUser ? ActivityType.SignUp : ActivityType.Login, true).pipe(switchMap(function() {
                        return _this.authorize(token).pipe(tap(function(dataUser) {
                            if (dataUser && sendGtmEvent) {
                                gtmInitialLoginEvent(dataUser);
                            }
                        }), takeWhile(function() {
                            return !observer.closed;
                        }));
                    })).subscribe({
                        complete: function() {
                            observer.complete();
                        },
                        error: function(error) {
                            _this.rollbar.error(error);
                            observer.error(error);
                        }
                    });
                }
            }
        },
        {
            key: "handleCognitoUserOnFailure",
            value: function handleCognitoUserOnFailure(param) {
                var _this = this;
                var observer = param.observer, isNewUser = param.isNewUser, username = param.username, error = param.error;
                var errorMessage = {
                    code: error.code,
                    name: error.name,
                    message: error.message,
                    stack: error.stack
                };
                if (observer) {
                    this.trackActivity(username, isNewUser ? ActivityType.SignUpFailed : ActivityType.LoginFailed, false, "".concat(awsService.translateAWSErrors(error.code, this.i18n, ''), " ").concat(JSON.stringify(errorMessage))).subscribe({
                        complete: function() {
                            _this.rollbar.error(error);
                            observer.error(error);
                        }
                    });
                }
            }
        },
        {
            key: "handleCognitoUserTotpRequired",
            value: function handleCognitoUserTotpRequired(param) {
                var observer = param.observer;
                this.isMfaCodeRequestedSubject.value = true;
                observer.next({
                    mfaType: MfaTypes.Authenticator
                });
                observer.complete();
            }
        },
        {
            key: "handleCognitoUserMfaRequired",
            value: function handleCognitoUserMfaRequired(param) {
                var observer = param.observer, password = param.password;
                this.isMfaCodeRequestedSubject.value = true;
                // Password is already saved if multiple MFA methods are enabled
                if (password) this.currentCognitoUserPasswordSubject.value = password;
                observer.next({
                    mfaType: MfaTypes.SMS
                });
                observer.complete();
            }
        },
        {
            key: "setIsMfaCodeRequested",
            value: function setIsMfaCodeRequested(value) {
                this.isMfaCodeRequestedSubject.value = value;
            }
        },
        {
            key: "authenticate",
            value: function authenticate(param) {
                var _this = this;
                var username = param.username, password = param.password, isNewUser = param.isNewUser, sendGtmEvent = param.sendGtmEvent;
                return new Observable(function(observer) {
                    if (!_this.currentCognitoUserSubject.value && _this.pool) {
                        _this.currentCognitoUserSubject.value = new CognitoUser({
                            Username: username,
                            Pool: _this.pool
                        });
                    }
                    var user = _this.currentCognitoUserSubject.value;
                    var clientName = getClientName(window.location.hostname);
                    var userAuthDetails = {
                        Username: username,
                        Password: password,
                        ClientMetadata: {
                            clientName: clientName
                        }
                    };
                    var authDetails = new AuthenticationDetails(userAuthDetails);
                    user === null || user === void 0 ? void 0 : user.authenticateUser(authDetails, {
                        onSuccess: function(data) {
                            _this.handleCognitoUserOnSuccess({
                                cognitoSession: data,
                                observer: observer,
                                isNewUser: isNewUser,
                                username: username,
                                sendGtmEvent: sendGtmEvent
                            });
                        },
                        onFailure: function(error) {
                            _this.handleCognitoUserOnFailure({
                                observer: observer,
                                isNewUser: isNewUser,
                                username: username,
                                error: error
                            });
                        },
                        totpRequired: function() {
                            _this.handleCognitoUserTotpRequired({
                                observer: observer
                            });
                        },
                        mfaRequired: function() {
                            _this.handleCognitoUserMfaRequired({
                                observer: observer,
                                password: password
                            });
                        },
                        newPasswordRequired: function() {
                            _this.trackActivity(username, ActivityType.NewPasswordRequired, true).subscribe({
                                complete: function() {
                                    observer.error();
                                }
                            });
                        },
                        selectMFAType: function() {
                            _this.isMfaCodeRequestedSubject.value = true;
                            _this.currentCognitoUserPasswordSubject.value = password;
                            _this.cognitoUserHasMultipleMfaMethodsSubject.value = true;
                            observer.next();
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "loadContractDocument",
            value: function loadContractDocument(fileId, cognitoToken) {
                var headers = {
                    Authorization: "Bearer ".concat(cognitoToken)
                };
                return this.axios.get("".concat(this.baseEndpoint, "/file/download?fileId=").concat(fileId), {
                    headers: headers,
                    responseType: 'arraybuffer'
                }).pipe(map(function(param) {
                    var data = param.data;
                    return data;
                }));
            }
        },
        {
            key: "createUser",
            value: function createUser(user) {
                var _this = this;
                this.isLoadingSubject.value = true;
                return this.axios.post("".concat(this.accountEndpoint, "/create-user"), user).pipe(map(function(response) {
                    return _object_spread_props(_object_spread({}, response.data), {
                        isNewUser: response.status === 201
                    });
                }), finalize(function() {
                    _this.isLoadingSubject.value = false;
                }), catchError(function(error) {
                    var errorCode = errorToString(error);
                    if (Object.values(AuthErrorCodes).includes(errorCode)) {
                        return throwError(error);
                    }
                    return _this.catchAwsErrors(error);
                }));
            }
        },
        {
            key: "getClients",
            value: function getClients(vendorCode) {
                var _this = this;
                this.isLoadingSubject.value = true;
                return this.axios.get("".concat(this.clientEndpoint, "?vendorCode=").concat(vendorCode)).pipe(map(function(param) {
                    var data = param.data;
                    _this.clientListSubject.value = data;
                    return data;
                }), finalize(function() {
                    _this.isLoadingSubject.value = false;
                }));
            }
        },
        {
            key: "sendUserActivityTrackData",
            value: function sendUserActivityTrackData(data) {
                return this.axios.post("".concat(this.baseEndpoint, "/User/track-activity"), data);
            }
        },
        {
            key: "switchProfileType",
            value: function switchProfileType(profileType, params) {
                var _this = this;
                return this.axios.get("".concat(this.accountEndpoint, "/switch-profile/").concat(profileType), {
                    params: params
                }).pipe(map(function(param) {
                    var data = param.data;
                    var authData = _this.authStorage.get();
                    var _authData_supportUserId;
                    _this.setAuthStorage(_object_spread_props(_object_spread({}, data), {
                        supportUserId: (_authData_supportUserId = authData === null || authData === void 0 ? void 0 : authData.supportUserId) !== null && _authData_supportUserId !== void 0 ? _authData_supportUserId : null
                    }));
                }));
            }
        },
        {
            key: "getPasswordInfo",
            value: function getPasswordInfo(email, recaptchaToken) {
                var headers = {
                    recaptchaToken: recaptchaToken
                };
                return this.axios.get("".concat(this.accountEndpoint, "/user-password-info?").concat(new URLSearchParams({
                    email: email,
                    originBase: encodeURIComponent(window.location.origin)
                })), {
                    headers: headers
                }).pipe(map(function(param) {
                    var data = param.data;
                    return data;
                }));
            }
        },
        {
            key: "sendVerficationCode",
            value: function sendVerficationCode(code, recaptchaToken, optionalParams) {
                var _this = this;
                return this.axios.post("".concat(this.accountEndpoint, "/password-verification-code"), {
                    code: code,
                    recaptchaToken: recaptchaToken,
                    originBase: encodeURIComponent(window.location.origin),
                    isOtp: optionalParams === null || optionalParams === void 0 ? void 0 : optionalParams.isOtp,
                    language: optionalParams === null || optionalParams === void 0 ? void 0 : optionalParams.language
                }).pipe(map(function() {
                    _this.trackActivity(code, ActivityType.OtpRequest, false, 'Verification code generated successfully').subscribe();
                }));
            }
        },
        {
            key: "sendRestrictedUserVerificationCode",
            value: function sendRestrictedUserVerificationCode(email, recaptchaToken, clientCode, language) {
                return this.axios.post("".concat(this.accountEndpoint, "/restricted-user-verification-code"), {
                    email: email,
                    recaptchaToken: recaptchaToken,
                    clientCode: clientCode,
                    language: language,
                    originBase: encodeURIComponent(window.location.origin),
                    vendorCode: getVendorCode()
                }).pipe(map(function(param) {
                    var data = param.data;
                    return data;
                }));
            }
        },
        {
            key: "restrictedAccessSignUp",
            value: function restrictedAccessSignUp(email, recaptchaToken, verificationCode, clientCode) {
                var _this = this;
                var userData = {
                    email: email,
                    recaptchaToken: recaptchaToken,
                    verificationCode: verificationCode,
                    clientCode: clientCode,
                    originBase: window.location.origin,
                    callbackURL: "".concat(window.location.origin, "/auth-return"),
                    authPortalBase: this.authPortalBaseUrl,
                    vendorCode: getVendorCode()
                };
                return this.axios.post("".concat(this.accountEndpoint, "/restricted-access/sign-in"), userData).pipe(map(function(param) {
                    var data = param.data;
                    _this.clearRestrictedViewStorage();
                    _this.setAuthStorage(data);
                    return data;
                }));
            }
        },
        {
            key: "validateVerficationCode",
            value: function validateVerficationCode(code, verificationCode, recaptchaToken) {
                var _this = this;
                return this.axios.post("".concat(this.accountEndpoint, "/password-verification-code-validity"), {
                    code: code,
                    verificationCode: verificationCode,
                    recaptchaToken: recaptchaToken
                }).pipe(map(function(param) {
                    var data = param.data;
                    var isCodeValid = data.isCodeValid, hasCodeExpired = data.hasCodeExpired;
                    var isSuccess = isCodeValid && !hasCodeExpired;
                    if (isSuccess) {
                        _this.trackActivity(code, ActivityType.OtpVerification, isSuccess, 'Verification code validated successfully.').subscribe();
                    } else {
                        _this.trackActivity(code, ActivityType.OtpVerification, isSuccess, "Verification code validation failed. ".concat(JSON.stringify(data))).subscribe();
                    }
                    return data;
                }));
            }
        },
        {
            key: "signUp",
            value: function signUp(email, password, recaptchaToken) {
                var _this = this;
                var data = {
                    email: email,
                    password: password,
                    recaptchaToken: recaptchaToken,
                    originBase: window.location.origin,
                    callbackURL: "".concat(window.location.origin, "/auth-return"),
                    clientCode: getClientCode(),
                    destinationURL: '',
                    authPortalBase: this.authPortalBaseUrl,
                    vendorCode: getVendorCode(),
                    profileType: AuthProfileType.Contractor,
                    language: this.i18n.language
                };
                return this.axios.post("".concat(this.accountEndpoint, "/signup"), data).pipe(switchMap(function() {
                    return _this.authenticate({
                        username: email,
                        password: password,
                        isNewUser: true,
                        sendGtmEvent: true
                    });
                }), catchError(this.catchAwsErrors));
            }
        },
        {
            key: "migrateSignUp",
            value: function migrateSignUp(email, password, recaptchaToken, verificationCode, userId) {
                var _this = this;
                var data = {
                    userId: userId,
                    email: email,
                    password: password,
                    recaptchaToken: recaptchaToken,
                    verificationCode: verificationCode,
                    originBase: window.location.origin,
                    callbackURL: "".concat(window.location.origin, "/auth-return"),
                    destinationURL: '',
                    authPortalBase: this.authPortalBaseUrl,
                    vendorCode: getVendorCode(),
                    language: this.i18n.language
                };
                return this.axios.post("".concat(this.accountEndpoint, "/migrated-user-signup"), data).pipe(switchMap(function() {
                    return _this.authenticate({
                        username: email,
                        password: password,
                        isNewUser: true,
                        sendGtmEvent: true
                    });
                }), catchError(this.catchAwsErrors));
            }
        },
        {
            key: "resetPassword",
            value: function resetPassword(email, password, recaptchaToken) {
                var _this = this;
                var data = {
                    email: email,
                    password: password,
                    recaptchaToken: recaptchaToken,
                    originBase: window.location.origin,
                    callbackURL: "".concat(window.location.origin, "/auth-return"),
                    destinationURL: '',
                    authPortalBase: this.authPortalBaseUrl,
                    vendorCode: getVendorCode(),
                    profileType: AuthProfileType.Contractor
                };
                return this.axios.post("".concat(this.accountEndpoint, "/signup"), data).pipe(switchMap(function() {
                    return _this.authenticate({
                        username: email,
                        password: password
                    });
                }), catchError(this.catchAwsErrors));
            }
        },
        {
            key: "changePassword",
            value: function changePassword(payload) {
                var _this = this;
                this.isLoadingSubject.value = true;
                return this.axios.post("".concat(this.accountEndpoint, "/change-password"), payload).pipe(finalize(function() {
                    _this.isLoadingSubject.value = false;
                }), catchError(function(error) {
                    var _error_response_data, _error_response;
                    return (error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.message) ? throwError(function() {
                        return new Error(error.response.data.message);
                    }) : _this.catchAwsErrors(error);
                }));
            }
        },
        {
            key: "deleteAccount",
            value: function deleteAccount() {
                var _this = this;
                this.isLoadingSubject.value = true;
                return this.axios.delete("".concat(this.accountEndpoint)).pipe(finalize(function() {
                    _this.isLoadingSubject.value = false;
                }), catchError(this.catchAwsErrors));
            }
        },
        {
            key: "getUserPermissions",
            value: function getUserPermissions() {
                var _this = this;
                this.isUserPermissionLoadingSubject.value = true;
                var request = forkJoin({
                    userPermissions: this.axios.get("".concat(this.baseEndpoint, "/SiteConfiguration/contractor-portal/features?baseUrl=").concat(window.location.origin)).pipe(map(function(param) {
                        var data = param.data;
                        return data;
                    })),
                    onboardingMeta: this.onboardingService.getOnboardingDashboardMeta().pipe(catchError(function() {
                        return of(null);
                    }))
                }).pipe(map(function(_param) {
                    var isJobEnabled = _param.userPermissions.isJobEnabled, onboardingMeta = _param.onboardingMeta, rest = _object_without_properties(_param.userPermissions, [
                        "isJobEnabled"
                    ]);
                    var _this_currentUser;
                    var isOnboardingEnabled = ((_this_currentUser = _this.currentUser) === null || _this_currentUser === void 0 ? void 0 : _this_currentUser.isEmailVerified) && onboardingMeta ? onboardingMeta === null || onboardingMeta === void 0 ? void 0 : onboardingMeta.hasOnboardingList : false;
                    var isOnboardingActive = onboardingMeta ? (onboardingMeta === null || onboardingMeta === void 0 ? void 0 : onboardingMeta.hasPackageInProgress) || (onboardingMeta === null || onboardingMeta === void 0 ? void 0 : onboardingMeta.hasSurvey) || (onboardingMeta === null || onboardingMeta === void 0 ? void 0 : onboardingMeta.hasPendingReview) || (onboardingMeta === null || onboardingMeta === void 0 ? void 0 : onboardingMeta.hasCompletedPackageEndDateNotExceeded) || (onboardingMeta === null || onboardingMeta === void 0 ? void 0 : onboardingMeta.hasCustomInformationRequestInProgress) || (onboardingMeta === null || onboardingMeta === void 0 ? void 0 : onboardingMeta.hasBankingChangeRequestInProgress) || (onboardingMeta === null || onboardingMeta === void 0 ? void 0 : onboardingMeta.hasCompletedInformationRequestEndDateNotExceeded) || (onboardingMeta === null || onboardingMeta === void 0 ? void 0 : onboardingMeta.hasOfferInformationRequestInProgress) || (onboardingMeta === null || onboardingMeta === void 0 ? void 0 : onboardingMeta.hasOfferAmendments) || (onboardingMeta === null || onboardingMeta === void 0 ? void 0 : onboardingMeta.isNewItemAvailable) || (onboardingMeta === null || onboardingMeta === void 0 ? void 0 : onboardingMeta.isDueDatesUpdated) : false;
                    var isResumeCopilotEnabled = _this.isResumeCopilotFeatureEnabled === 'true' && isJobEnabled && !isOnboardingActive;
                    _this.userPermissionsSubject.value = _object_spread_props(_object_spread({}, rest), {
                        isOnboardingEnabled: isOnboardingEnabled,
                        isResumeCopilotEnabled: isResumeCopilotEnabled,
                        isJobEnabled: isJobEnabled && !isOnboardingActive,
                        isOnboardingPendingReviewEnabled: !!(onboardingMeta === null || onboardingMeta === void 0 ? void 0 : onboardingMeta.hasPendingReview)
                    });
                }), finalize(function() {
                    _this.isUserPermissionLoadingSubject.value = false;
                }));
                return this.refreshPermission$.pipe(switchMap(function() {
                    return request;
                }));
            }
        },
        {
            key: "updateActivityEndTime",
            value: function updateActivityEndTime(creationToken) {
                return this.axios.put("".concat(this.userDetailEndpoint, "/activity/end"), {
                    creationToken: creationToken
                }).pipe(map(function(param) {
                    var data = param.data;
                    return data;
                }));
            }
        },
        {
            key: "updateActivityEndTimeUsingBeacon",
            value: function updateActivityEndTimeUsingBeacon(creationToken) {
                navigator.sendBeacon("".concat(this.userDetailEndpoint, "/activity/end/").concat(creationToken));
            }
        },
        {
            key: "trackActivity",
            value: function trackActivity(email, activityType, isSuccess, errorMessage, profileType, vendorCode, clientCode) {
                return this.axios.post("".concat(this.accountEndpoint, "/user-authentication-activity-log"), {
                    email: email,
                    activityType: activityType,
                    isSuccess: isSuccess,
                    errorMessage: errorMessage,
                    profileType: profileType,
                    vendorCode: vendorCode,
                    clientCode: clientCode
                }).pipe(map(function() {}));
            }
        },
        {
            key: "resendEmailVerification",
            value: function resendEmailVerification(destinationURL, loginType, newCPUser) {
                var _this = this;
                this.isLoadingSubject.value = true;
                return this.axios.post("".concat(this.accountEndpoint, "/resend-confirmation-code"), {
                    destinationURL: destinationURL,
                    loginType: loginType.toLowerCase(),
                    newCPUser: newCPUser || false
                }).pipe(finalize(function() {
                    _this.isLoadingSubject.value = false;
                }));
            }
        },
        {
            key: "sendVerifyOBEmail",
            value: function sendVerifyOBEmail(recipientEmail, recipientName) {
                var _this = this;
                this.isLoadingSubject.value = true;
                return this.axios.post("".concat(this.accountEndpoint, "/verify-onboarding-email"), {
                    recipientEmail: recipientEmail,
                    recipientName: recipientName,
                    originBase: window.location.origin
                }).pipe(finalize(function() {
                    _this.isLoadingSubject.value = false;
                }));
            }
        },
        {
            key: "signInGuestUser",
            value: function signInGuestUser(token, username, recaptchaToken, useSessionStorage) {
                var _this = this;
                return this.axios.post("".concat(this.accountEndpoint, "/guest-signin"), {
                    token: token,
                    username: username,
                    recaptchaToken: recaptchaToken
                }).pipe(map(function(param) {
                    var data = param.data;
                    if (!useSessionStorage) {
                        _this.setAuthStorage(data);
                    }
                    return data;
                }));
            }
        },
        {
            key: "codeSignIn",
            value: function codeSignIn(code, recaptchaToken, username) {
                var _this = this;
                return this.axios.post("".concat(this.accountEndpoint, "/code-signin"), {
                    code: code,
                    username: username,
                    recaptchaToken: recaptchaToken
                }).pipe(map(function(param) {
                    var data = param.data;
                    _this.clearRestrictedViewStorage();
                    _this.setAuthStorage(data);
                    return data;
                }));
            }
        },
        {
            key: "triggerRefreshPermission",
            value: function triggerRefreshPermission() {
                if (!this.isUserPermissionLoadingSubject.value) this.refreshPermissionSubject.value = true;
            }
        },
        {
            key: "handleGetUserAttributes",
            value: function handleGetUserAttributes(param) {
                var currentCognitoUser = param.currentCognitoUser;
                return new Observable(function(observer) {
                    currentCognitoUser.getUserAttributes(function(error, result) {
                        if (error) {
                            observer.error(error);
                        } else {
                            observer.next(result);
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: "handleUpdateCognitoUserAttributes",
            value: function handleUpdateCognitoUserAttributes(param) {
                var token = param.token, currentCognitoUser = param.currentCognitoUser, attributes = param.attributes;
                return new Observable(function(observer) {
                    currentCognitoUser.updateAttributes(attributes, function(error) {
                        if (error) {
                            observer.error(error);
                        } else {
                            observer.next(token);
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: "getVendorDetails",
            value: function getVendorDetails(vendorCode) {
                return this.axios.get("".concat(this.baseEndpoint, "/Vendor/by-code/").concat(vendorCode)).pipe(map(function(param) {
                    var data = param.data;
                    return data;
                }));
            }
        },
        {
            key: "getWopiInfo",
            value: function getWopiInfo(fileId) {
                return this.axios.get("".concat(this.baseEndpoint, "/File/wopi-info/").concat(fileId)).pipe(map(function(param) {
                    var data = param.data;
                    return data;
                }));
            }
        },
        {
            key: "getFboActivationStatus",
            value: function getFboActivationStatus() {
                return this.axios.get("".concat(this.accountEndpoint, "/fbo-activation-status")).pipe(map(function(param) {
                    var data = param.data;
                    return data;
                }));
            }
        },
        {
            key: "setAuthStorage",
            value: function setAuthStorage(data) {
                this.authStorage.set(data);
                this.authDataSubject.next(data);
                this.currentUser = data.user;
            }
        },
        {
            key: "clearAuthStorage",
            value: function clearAuthStorage() {
                this.authStorage.clear();
                this.authDataSubject.next(null);
                this.currentUser = null;
            }
        },
        {
            key: "catchAwsErrors",
            value: function catchAwsErrors(error) {
                var _this = this;
                var cognitoErrorCode = errorToString(error);
                return throwError(function() {
                    return new Error(awsService.translateAWSErrors(cognitoErrorCode, _this.i18n));
                });
            }
        }
    ], [
        {
            key: "getOrCreate",
            value: function getOrCreate() {
                var observable = new WindowedObservable(InjectableServices.AuthService);
                var state = observable.getLastEvent();
                if (state) {
                    return state;
                }
                var appType = new WindowedObservable(InjectableConfig.AppType).getLastEvent();
                if (appType && [
                    AppTypes.auth,
                    AppTypes.submission
                ].includes(appType)) {
                    throw new Error('Wrong Auth Service being used');
                }
                var instance = new AuthService();
                observable.publish(instance);
                return instance;
            }
        }
    ]);
    return AuthService;
}(BaseConfigService);
